(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var COOKIE_NAME = 'jiyu_market_suggestion_dismissed';
  var COOKIE_DAYS = 14;
  var SUGGESTIONS_PATH = 'browsing_context_suggestions.json';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init() {
    var host = document.querySelector('[data-market-suggestion]');
    if (!host) return;
    if (getCookie(COOKIE_NAME) === '1') return;

    var currentCountry = (host.dataset.currentCountry || '').toUpperCase();
    var currentLanguage = (host.dataset.currentLanguage || '').toLowerCase();
    var availableCountries = (host.dataset.availableCountries || '')
      .split(',')
      .map(function (c) { return c.trim().toUpperCase(); })
      .filter(Boolean);

    fetch(rootUrl() + SUGGESTIONS_PATH, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.detected_values) return;

        var detectedCountry = data.detected_values.country;
        var detectedLanguage = data.detected_values.language;
        if (!detectedCountry || !detectedCountry.handle) return;

        var detectedCountryCode = detectedCountry.handle.toUpperCase();

        if (detectedCountryCode === currentCountry) return;
        if (availableCountries.length > 0 && availableCountries.indexOf(detectedCountryCode) === -1) return;

        var detectedLanguageCode = detectedLanguage && detectedLanguage.handle
          ? detectedLanguage.handle.toLowerCase()
          : currentLanguage;

        renderBanner(host, {
          countryCode: detectedCountryCode,
          countryName: detectedCountry.name || detectedCountryCode,
          languageCode: detectedLanguageCode
        });
      })
      .catch(function () { /* silent */ });
  }

  function renderBanner(host, suggestion) {
    var strings = window.marketSuggestionStrings || {};
    var country = escapeHtml(suggestion.countryName);
    var message = (strings.message || '').split('[country]').join(country);
    var switchLabel = (strings.switch_button || '').split('[country]').join(country);
    var dismissLabel = strings.dismiss_button || 'Stay on current site';
    var closeLabel = strings.close_label || 'Close';

    var banner = document.createElement('aside');
    banner.className = 'market-suggestion';
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', strings.title || 'Region suggestion');
    banner.innerHTML =
      '<div class="market-suggestion__inner">' +
        '<button type="button" class="market-suggestion__close" data-action="dismiss" aria-label="' + escapeAttr(closeLabel) + '">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
            '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<p class="market-suggestion__text">' + message + '</p>' +
        '<div class="market-suggestion__actions">' +
          '<button type="button" class="market-suggestion__btn market-suggestion__btn--accept" data-action="accept">' + switchLabel + '</button>' +
          '<button type="button" class="market-suggestion__btn market-suggestion__btn--dismiss" data-action="dismiss">' + escapeHtml(dismissLabel) + '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(banner);
    requestAnimationFrame(function () { banner.classList.add('market-suggestion--visible'); });

    banner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.dataset.action;
      if (action === 'accept') {
        submitSwitch(host, suggestion.countryCode, suggestion.languageCode);
      } else if (action === 'dismiss') {
        setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
        banner.classList.remove('market-suggestion--visible');
        setTimeout(function () { banner.remove(); }, 300);
      }
    });
  }

  function submitSwitch(host, countryCode, languageCode) {
    var form = host.querySelector('form');
    if (!form) return;
    var countryInput = form.querySelector('[data-country-input]');
    var languageInput = form.querySelector('[data-language-input]');
    var returnInput = form.querySelector('[data-return-to]');
    if (countryInput) countryInput.value = countryCode;
    if (languageInput) languageInput.value = languageCode;
    if (returnInput) returnInput.value = stripLocalePrefix(window.location.pathname) + window.location.search;
    form.submit();
  }

  // Strip the current market's locale prefix (e.g. "/en-ca/products/foo" -> "/products/foo")
  // so Shopify can re-apply the new market's prefix without double-prefixing or 404ing.
  function stripLocalePrefix(pathname) {
    var root = rootUrl();
    if (root === '/' || !pathname || pathname.indexOf(root) !== 0) return pathname || '/';
    var rest = pathname.substring(root.length);
    return '/' + (rest.indexOf('/') === 0 ? rest.substring(1) : rest);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
